import type { NodeMock, StatePreset } from "../mock-types";

export const sideSelectMock: NodeMock = {
  label: "Side Select",
  description: "Winning team picks which side to play",
  state: () => ({
    sides: [
      { id: "attack", name: "Attack", description: "Start on the attacking side" },
      { id: "defense", name: "Defense", description: "Start on the defending side" },
    ],
    teamSides: {},
    selectingTeam: 0,
    coinFlipResult: { winningTeam: 0 },
  }),
  config: {
    timeoutSeconds: 20,
    selectionMethod: "winner_choice",
    labels: {
      title: "Side Selection",
    },
  },
};

export const sideSelectPresets: StatePreset[] = [
  {
    label: "Choosing",
    build: ({ defaultState }) => ({
      state: { ...defaultState, teamSides: {} },
    }),
  },
  {
    label: "Selected",
    build: ({ defaultState }) => ({
      state: { ...defaultState, teamSides: { 0: "attack", 1: "defense" } },
    }),
  },
];
